import React from 'react';
import ButtonLink from '../../common/TrackedButtonLink';

const TotalProductCount = ({ productTotal, name, link }) => {
	return (
		<div className="row product-count">
			<div className="col">
				<p>
					We have
					<span className="total"> { productTotal } </span>
					{ name } to protect you.
				</p>
				<ButtonLink
					className="btn-primary"
					to={ `/products/${link}` }
				>
					View All
				</ButtonLink>
			</div>
		</div>
	);
};

export default TotalProductCount;


// WEBPACK FOOTER //
// ./src/pages/category/common/TotalProductCount.js